
import { Perfiles } from '@infotrack/presentacion-modulosbase';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import { useSelector } from 'react-redux';
import { seguridadToken } from 'Infotrack@Modelos/conexiones';
import React from 'react';

const Perfil: React.FunctionComponent = () => {
    const idAplicacion = useSelector(
        (e: IEstadoGlobal) => e.estadoAutenticacion.usuarioAplicacionAgenciaActual!.IdAplicacion
    );

    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    return <Perfiles idAplicacion={idAplicacion!} idEmpresa={idEmpresa} seguridad={seguridadToken} />;
};

export default Perfil;